import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Hidden from "@material-ui/core/Hidden";
import Fab from "@material-ui/core/Fab";
import ListIcon from "@material-ui/icons/List";
import Drawer from "@material-ui/core/Drawer";

import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import ProductCard from "./productCard";
import ProductSpec from "./productSpec";
import ScrollToTop from "./scrollToTop";

import localizationManager from "./localizationManager";

import {
  withStyles,
  withTheme,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import {
  Route,
  Link,
  Switch,
  Redirect,
} from "react-router-dom";

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: "#2196f3",
    },
    secondary: {
      main: "#E44A4B",
    },
  },
});

const styles = (theme) => ({
  layout: {
    width: "auto",
    marginTop: theme.spacing.unit * 12,
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: "80%",
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: theme.spacing.unit * 12,
    },
  },
  divider: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  root: {
    width: "100%",
    maxWidth: 225,
    // backgroundColor: theme.palette.background.paper
  },
  list: {
    paddingLeft: theme.spacing.unit * 5,
  },
  nested: {
    paddingLeft: theme.spacing.unit * 7,
    paddingTop: theme.spacing.unit / 2,
    paddingBottom: theme.spacing.unit / 2,
  },
  fab: {
    [theme.breakpoints.down(960)]: {
      position: "fixed",
      top: theme.spacing.unit * 10,
      left: theme.spacing.unit * 1.5,
      zIndex: 1,
    },
  },
  gridRoute: {
    minHeight: 1200,
  },
});

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandPSW: true,
      expandMSW: true,
      leftDrawer: false,
      expandLegacy: false,
    };
  }

  toggleState = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  render() {
    const { classes } = this.props;
    // Helper to get current prefix using centralized langUrl
    const getPrefix = () => {
      const { match } = this.props;
      const lang = match && match.params && match.params.lang;
      // If URL has a lang slug, use centralized getLangPrefix for the internal lang
      // For legacy URLs (no lang param), return empty string to keep links working
      if (lang) {
        // The route param is the URL slug (e.g. "zh-tw"), but getLangPrefix expects internal lang.
        // Since slugs are already lowercase and getLangPrefix handles it, just use `/${lang}`
        return `/${lang}`;
      }
      return "";
    };
    const prefix = getPrefix();
    
    const sideList = (
      <Grid item md={3}>
        {/* //TODO this is nestedList but i can't find a way to make router work when it's a separated component*/}
        <List component="nav" className={classes.root} dense={true}>
          <ListSubheader disableSticky component="div">
            {localizationManager.getLocalString("@@new_products")}
          </ListSubheader>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary={localizationManager.getLocalString("@@new_products")}
            />
          </ListItem>
          <Divider />
          <ListSubheader disableSticky component="div">
            {localizationManager.getLocalString("@@dc_ac_inverter")}
          </ListSubheader>
          <ListItem
            button
            onClick={this.toggleState("expandPSW", !this.state.expandPSW)}
            className={classes.list}
          >
            <ListItemText
              primary={localizationManager.getLocalString("@@pure_sine_wave")}
            />
            {this.state.expandPSW ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.expandPSW} timeout="auto" unmountOnExit>
            <List component="div" dense={true}>
              <ListItem
                button
                className={classes.nested}
                component={Link}
                to={`${prefix}/product/sn-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary={localizationManager.getLocalString("@@sn_series")}
                  secondary={localizationManager.getLocalString(
                    "@@classic_lcd"
                  )}
                />
              </ListItem>
              <ListItem
                button
                className={classes.nested}
                component={Link}
                to={`${prefix}/product/sn-bt-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary={localizationManager.getLocalString("@@sn_bt_series")}
                  secondary={localizationManager.getLocalString(
                    "@@smartphone_control"
                  )}
                />
              </ListItem>
              <ListItem
                button
                className={classes.nested}
                component={Link}
                to={`${prefix}/product/sn-t-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary={localizationManager.getLocalString("@@sn_t_series")}
                  secondary={localizationManager.getLocalString(
                    "@@with_ats"
                  )}
                />
              </ListItem>
            </List>
          </Collapse>
          <ListItem
            button
            onClick={this.toggleState("expandMSW", !this.state.expandMSW)}
            className={classes.list}
          >
            <ListItemText
              primary={localizationManager.getLocalString(
                "@@modified_sine_wave"
              )}
            />
            {this.state.expandMSW ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.expandMSW} timeout="auto" unmountOnExit>
            <List component="div" dense={true}>
              <ListItem
                button
                className={classes.nested}
                component={Link}
                to={`${prefix}/product/hp-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary={localizationManager.getLocalString("@@hp_series")}
                  secondary={localizationManager.getLocalString("@@compact")}
                />
              </ListItem>
              <ListItem
                button
                className={classes.nested}
                component={Link}
                to={`${prefix}/product/sp-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary={localizationManager.getLocalString("@@sp_series")}
                  secondary={localizationManager.getLocalString("@@classic")}
                />
              </ListItem>
            </List>
          </Collapse>
          <Divider />
          <ListSubheader disableSticky component="div">
            {localizationManager.getLocalString("@@dc_ac_inverter_charger")}
          </ListSubheader>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/sn-c-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary={localizationManager.getLocalString("@@pure_sine_wave")}
              secondary={localizationManager.getLocalString("@@sn_c_series")}
            />
          </ListItem>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/sn-h-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary={localizationManager.getLocalString("@@pure_sine_wave")}
              secondary={localizationManager.getLocalString("@@sn_h_series")}
            />
          </ListItem>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/hp-c-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary={localizationManager.getLocalString(
                "@@modified_sine_wave"
              )}
              secondary={localizationManager.getLocalString("@@hp_c_compact")}
            />
          </ListItem>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/sp-c-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary={localizationManager.getLocalString(
                "@@modified_sine_wave"
              )}
              secondary={localizationManager.getLocalString("@@sp_c_classic")}
            />
          </ListItem>
          <Divider />
          <ListSubheader disableSticky component="div">
            UPS
          </ListSubheader>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/sn-u-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary={localizationManager.getLocalString("@@pure_sine_wave")}
              secondary={localizationManager.getLocalString("@@sn_u_series")}
            />
          </ListItem>
          <Divider />
          <ListSubheader disableSticky component="div">
            {localizationManager.getLocalString("@@dc_dc_converter")}
          </ListSubheader>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/dc-1224-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary="DC 12V to 24V"
              secondary={localizationManager.getLocalString("@@boost_step_up")}
            />
          </ListItem>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/dc-2412-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary="DC 24V to 12V"
              secondary={localizationManager.getLocalString("@@buck_step_down")}
            />
          </ListItem>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/dc-48-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary="DC 48V"
              secondary={localizationManager.getLocalString("@@buck_step_down")}
            />
          </ListItem>
          <Divider />
          <ListSubheader disableSticky component="div">
            {localizationManager.getLocalString("@@battery_charger")}
          </ListSubheader>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/ad-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary={localizationManager.getLocalString("@@ad_series")}
              secondary="12/24/48V"
            />
          </ListItem>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/dcc-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary={localizationManager.getLocalString("@@dcc_series")}
              secondary={localizationManager.getLocalString("@@dcc_des")}
            />
          </ListItem>
          <Divider />
          {/* <ListSubheader disableSticky component="div">
            Solar
          </ListSubheader>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to="/product/sc-series"
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText primary="Solar Charge Controller" />
          </ListItem>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to="/product/ls-series"
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText primary="Solar Inverter" />
          </ListItem>
          <Divider /> */}
          <ListSubheader disableSticky component="div">
            {localizationManager.getLocalString("@@accessories")}
          </ListSubheader>
          <ListItem
            button
            className={classes.list}
            component={Link}
            to={`${prefix}/product/rc-series`}
            onClick={this.toggleState("leftDrawer", false)}
          >
            <ListItemText
              primary={localizationManager.getLocalString("@@remote_control")}
            />
          </ListItem>
          <Divider />
          <ListSubheader disableSticky component="div">
            {localizationManager.getLocalString("@@others")}
          </ListSubheader>
          <ListItem
            button
            onClick={this.toggleState("expandLegacy", !this.state.expandLegacy)}
            className={classes.list}
          >
            <ListItemText
              primary={localizationManager.getLocalString("@@specialized")}
            />
            {this.state.expandLegacy ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.expandLegacy} timeout="auto" unmountOnExit>
            <List component="div" dense={true}>
              <ListItem
                button
                className={classes.list}
                component={Link}
                to={`${prefix}/product/es-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary={localizationManager.getLocalString("@@es_series")}
                  secondary={localizationManager.getLocalString(
                    "@@energy_saving_inverter"
                  )}
                />
              </ListItem>
              <ListItem
                button
                className={classes.list}
                component={Link}
                to={`${prefix}/product/1224-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary="12V/24V Series"
                  secondary={localizationManager.getLocalString(
                    "@@dual_input_types_inverter"
                  )}
                />
              </ListItem>
              <ListItem
                button
                className={classes.list}
                component={Link}
                to={`${prefix}/product/ats-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary={localizationManager.getLocalString("@@ats_series")}
                  secondary={localizationManager.getLocalString(
                    "@@auto_ac_transfer_switch"
                  )}
                />
              </ListItem>
              <ListItem
                button
                className={classes.list}
                component={Link}
                to={`${prefix}/product/dc-4in1-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary="DC 4-IN-1"
                  secondary={localizationManager.getLocalString(
                    "@@buck_boost_10_60v"
                  )}
                />
              </ListItem>
              <ListItem
                button
                className={classes.list}
                component={Link}
                to={`${prefix}/product/ls-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary={localizationManager.getLocalString(
                    "@@solar_inverter"
                  )}
                  secondary="PWM 300~5000W"
                />
              </ListItem>
              <ListItem
                button
                className={classes.list}
                component={Link}
                to={`${prefix}/product/sc-series`}
                onClick={this.toggleState("leftDrawer", false)}
              >
                <ListItemText
                  primary={localizationManager.getLocalString(
                    "@@solar_charge_controller"
                  )}
                  secondary="PWM 15~50A"
                />
              </ListItem>
            </List>
          </Collapse>
        </List>
      </Grid>
    );

    return (
      // Nested Router removed to match parent history
      <ScrollToTop>
        <MuiThemeProvider theme={theme}>
          <React.Fragment>
              <CssBaseline />
              <main>
                <div className={classNames(classes.layout)}>
                  <Drawer
                    open={this.state.leftDrawer}
                    onClose={this.toggleState("leftDrawer", false)}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      // onClick={this.toggleDrawer("leftDrawer", false)}
                      // onKeyDown={this.toggleDrawer("leftDrawer", false)}
                    >
                      {sideList}
                    </div>
                  </Drawer>
                  <Grid item xs={12}>
                    <Hidden mdUp>
                      <Fab
                        className={classes.fab}
                        color="default"
                        size="medium"
                        onClick={this.toggleState("leftDrawer", true)}
                      >
                        <ListIcon />
                      </Fab>
                    </Hidden>
                    <Typography
                      component="h3"
                      variant="h5"
                      gutterBottom
                      color="textSecondary"
                      align="center"
                    >
                      {localizationManager.getLocalString("@@product")}
                    </Typography>
                  </Grid>
                  <Divider variant="middle" className={classes.divider} />
                  <Grid container spacing={40}>
                    <Hidden smDown>{sideList}</Hidden>
                    <Hidden mdUp>
                      <Grid item sm={1} />
                    </Hidden>
                    <Grid item sm={11} md={9} className={classes.gridRoute}>
                      <Switch>
                        <Route
                          exact
                          path={["/product/new", "/:lang(en|ja|zh-tw|zh)/product/new"]}
                          render={() => (
                            <Redirect to={`${prefix}/product`} />
                          )}
                        />
                        <Route
                          path={["/product/:productType/:productNum", "/:lang(en|ja|zh-tw|zh)/product/:productType/:productNum"]}
                          render={(props) => (
                            <ProductSpec
                              {...props}
                              cartCallback={this.props.cartCallback}
                              cart={this.props.cart}
                            />
                          )}
                        />
                        <Route
                          path={["/product/:productType", "/:lang(en|ja|zh-tw|zh)/product/:productType"]}
                          render={(props) => (
                            <ProductCard
                              {...props}
                              cartCallback={this.props.cartCallback}
                              cart={this.props.cart}
                            />
                          )}
                        />
                        <Route
                          render={(props) => (
                            <ProductCard
                              {...props}
                              match={{
                                ...props.match,
                                params: {
                                  ...props.match.params,
                                  lang: this.props.match.params.lang,
                                  productType: "new",
                                },
                              }}
                              cartCallback={this.props.cartCallback}
                              cart={this.props.cart}
                            />
                          )}
                        />
                      </Switch>
                    </Grid>
                  </Grid>
                </div>
              </main>
            </React.Fragment>
          </MuiThemeProvider>
        </ScrollToTop>

    );
  }
}

Product.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withTheme(theme)(withStyles(styles)(Product));
